import axios from "axios";
import {
	APPROVAL_EMPLOYEES,
	APPROVAL_GROUPS_COMPANIES,
	APPROVAL_RESPONSABLES,
	APPROVE_COUPON,
	CANCEL_APPROVED_COUPON,
	COMPANY_EMPLOYEES,
	CONTRACT_DOCUMENT_SIGNATURE_REQUEST,
	CONTRACT_OBSERVATION,
	COUPON_RANGE_VALIDATION,
	COUPON_REQUEST_RESPONSIBLE_EMAILS,
	EMPLOYEES_ANNIVERSARY,
	EMPLOYEES_BIRTHDAYS,
	EMPLOYEES_BIRTHDAYS_CURRENT,
	EMPLOYEES_VACATIONS_RESUME,
	EMPLOYEE_CONTRACTS_ONE,
	EMPLOYEE_CONTRACTS_THREE,
	EMPLOYEE_CONTRACTS_TWO,
	EMPLOYEE_LOANS_CURRENCIES,
	EMPLOYEE_LOANS_ONE,
	EMPLOYEE_LOANS_THREE,
	EMPLOYEE_LOANS_TWO,
	EMPLOYEE_LOANS_TYPES,
	EMPLOYEE_LOAN_CANCEL_RESULT,
	EMPLOYEE_LOAN_DETAILS,
	EMPLOYEE_LOAN_PERIOD,
	EMPLOYEE_LOAN_REQUEST,
	EMPLOYEE_LOAN_UPDATE_NOTE,
	EMPLOYEE_PAYMENT_SLIPS_ONE,
	EMPLOYEE_PAYMENT_SLIPS_THREE,
	EMPLOYEE_PAYMENT_SLIPS_TWO,
	EMPLOYEE_RECORDS_ONE,
	EMPLOYEE_RECORDS_THREE,
	EMPLOYEE_RECORDS_TWO,
	EMPLOYEE_VACATIONS,
	GET_COLLEGES,
	GET_CONTACTS,
	GET_EMPLOYEE_INFORMATION,
	GET_EMPLOYEE_RIGHT_HOLDERS,
	GET_EMPLOYEE_TRAINING,
	GET_HEALTH_PLAN,
	GET_STAFF_POSITIONS,
	GET_VACATIONS_RESUME,
	GET_YEAR_HOLIDAYS,
	LOANS_TO_MY_CHARGE_HISTORY_ONE,
	LOANS_TO_MY_CHARGE_HISTORY_TWO,
	LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE,
	LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE,
	LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO,
	PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST,
	PENDING_COUPONS_EMPLOYEES_HISTORY_ONE,
	PENDING_COUPONS_EMPLOYEES_HISTORY_THREE,
	PENDING_COUPONS_EMPLOYEES_HISTORY_TWO,
	PENDING_COUPONS_EMPLOYEES_ONE,
	PENDING_COUPONS_EMPLOYEES_THREE,
	PENDING_COUPONS_EMPLOYEES_TWO,
	RECORD_DOCUMENT_SIGNATURE_REQUEST,
	SET_EMPLOYEE_TRAINING,
	UPDATE_EMPLOYEE_RIGHT_HOLDERS,
	UPDATE_USER_DATA,
	USER_ASSIGNED_COMPANIES,
	BANK_ACCOUNTS_CONFIG,
	BANK_ACCOUNTS_LIST,
	BANKS_LIST,
	BANK_ACCOUNT_ADD,
	BANK_ACCOUNT_UPDATE,
	BANK_ACCOUNT_DELETE,
	CURRENCIES_LIST_GENERIC,
	IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_SCHEME_TYPES,
	IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE
} from "../constants/signalRequestConsts";
import { getDatestring } from "../utils/date";
import { store } from "../store";
import { UserDataToUpdate, UserUpdateRightHolder, UserUpdateTraining } from "../interfaces/auth.interface";
import { S10ContactsRequest, S10CouponsToMyChargePartial } from "../interfaces/s10Employees.interface";
import { refreshToken } from "../store/slices/auth";
import { InMyChargeEmployeeContractsRequestFilter, InMyChargeEmployeeContractsRequestId, InMyChargeEmployeeDocumentsRequestFilter, InMyChargeEmployeeDocumentsRequestId, InMyChargeEmployeePaymentSlipsRequestFilter, InMyChargeEmployeePaymentSlipsRequestId, LoansToMyChargeRequestId } from "../store/slices/userRequests";


const signalApi = axios.create({
	baseURL: `${process.env.REACT_APP_SIGNALR_URL}/api/S10ERP`,
});

signalApi.interceptors.response.use(
	(response) => {
		if (response?.data?.message === "No se encontraron clientes activos para la conexión") {
			const oldToken = response.config.headers.Token;
			console.log("retring, old token: " + oldToken);
			refreshToken(response.config.headers.Token);
			setTimeout(() => {
				const authCompanySelectedState = store.getState().auth.companyselected;
				if (response.config.headers.Token === authCompanySelectedState?.Token) {
					console.log("retry has failed");
					// store.dispatch(logout());
					return;
				}
				console.log("retry has worked: " + authCompanySelectedState?.Token);
				const newRequest = {
					...response.config,
					headers: {
						...response.config.headers,
						Authorization: `Bearer ${authCompanySelectedState?.Token}`,
					},
				};
				return axios(newRequest);
			}, 1);
		}
		return response;
	},
	(error) => {
		// Handle errors as usual
		return Promise.reject(error);
	}
);

export const signalGenericRequest = async (requestId: string, request: string, HasOutputParam: boolean = false) => {
	const companyselected = store.getState().auth.companyselected;
	const body = {
		HasOutputParam,
		ObjectName: request,
		RequestId: requestId,
		SignalRConnectionID: await localStorage.getItem("connectionId"),
		// SecurityUserId: userId
	};
	const headers = {
		Token: companyselected?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
	};
	const result = await signalApi.post(
		"/RequestS10ERPData",
		body,
		{ headers, }
	).catch((error: any) => {
		console.log(error);
		return { status: 400, data: { isSuccess: false } }
	});
	if (result.status !== 200 || !result.data?.isSuccess) {
		console.log(result)
		if (result?.data?.message === "No se encontraron clientes activos para la conexión") {
			// window.location.reload();
		}
	}
	return result;
}

export const signalGenericTransportDataRequest = async (requestId: string, request: string, HasOutputParam: boolean = false) => {
	const companyselected = store.getState().auth.companyselected;
	const body = {
		HasOutputParam,
		ObjectName: request,
		RequestId: requestId,
		SignalRConnectionID: await localStorage.getItem("connectionId"),
		SecurityUserId: companyselected?.Code,
		AdditionalValues: '',
		MultipleObject: false,
	};
	const headers = {
		Token: companyselected?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
	};
	const result = await signalApi.post(
		"/RequestS10ERPTransportData",
		body,
		{ headers, }
	).catch((error: any) => {
		console.log(error);
		return { status: 400, data: { isSuccess: false } }
	});
	if (result.status !== 200 || !result.data?.isSuccess) {
		console.log(result)
		if (result?.data?.message === "No se encontraron clientes activos para la conexión") {
			// window.location.reload();
		}
	}
	return result;
}

export const getEmployeesBithdays = async (month = 0, pageNumber = 1, pageSize = 10) => {
	if (month === 0) {
		await signalGenericRequest(
			EMPLOYEES_BIRTHDAYS_CURRENT,
			`dbo.S10_15_ProyectoIdentificadorEsquema_ListarPersonalOnomasticoPaginado ${pageSize}, ${pageNumber}`
		);
	} else {
		await signalGenericRequest(
			EMPLOYEES_BIRTHDAYS,
			`dbo.s10_15_ProyectoIdentificadorEsquema_ListarPersonalOnomastico ${month}`
		);
	}
}
export const getEmployeesAnniversary = async (pageNumber = 1, pageSize = 10) => {
	await signalGenericRequest(
		EMPLOYEES_ANNIVERSARY,
		`dbo.S10_15_ProyectoIdentificadorEsquema_ListarPersonalAniversarioPaginado ${pageSize}, ${pageNumber}`
	);
}

// @FiltroFirmado TINYINT = 0 --0:Todos 1:Firmados 2:Sin Firmar
export const getEmployeePaySlips = async (signedFilter: 0 | 1 | 2, requestId: (typeof EMPLOYEE_PAYMENT_SLIPS_ONE | typeof EMPLOYEE_PAYMENT_SLIPS_TWO | typeof EMPLOYEE_PAYMENT_SLIPS_THREE)) => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		requestId,
		`dbo.S10_15_BoletaNomina_PorSocioNegocioConFiltro '${companyselected?.Code}',${signedFilter}`
	);
}

export const setDocumentSignature = async (
	code: string,
	requestId: typeof PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST
) => {
	await signalGenericRequest(
		requestId,
		`dbo.S10_15_BoletaNomina_Firma '${code}'`
	);
}

export const setRecordSignature = async (
	ruc: string,
	userDocument: string,
	documentType: string,
	documentNumber: string,
	requestId: typeof RECORD_DOCUMENT_SIGNATURE_REQUEST
) => {
	await signalGenericRequest(
		requestId,
		`dbo.s10_15_DocumentoPersonal_Firmado '${ruc}','${userDocument}','${documentType}','${documentNumber}', 'null'`,
	);
}

export const setDocumentContract = async (
	code: string,
	requestId: typeof CONTRACT_DOCUMENT_SIGNATURE_REQUEST
) => {
	await signalGenericRequest(
		requestId,
		`dbo.S10_15_IdentificadorContrato_Aceptar '${code}'`,
	);
}

export const getEmployeeVacations = async () => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		EMPLOYEE_VACATIONS,
		`dbo.s10_15_Identificador_ListarVacacionProgramada '${companyselected?.Code}'`,
	);
}

// @FiltroFirmado TINYINT = 0 --0:Todos 1:Firmados 2:Sin Firmar
export const getEmployeeRecords = async (status: 0 | 1 | 2, requestId: (typeof EMPLOYEE_RECORDS_ONE | typeof EMPLOYEE_RECORDS_TWO | typeof EMPLOYEE_RECORDS_THREE)) => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		requestId,
		`dbo.S10_15_DocumentoPersonal_PorSocioNegocioConFiltro '${companyselected?.Code}',${status}`,
	);
}


// @signedFilter TINYINT = 0, --0:Todos 1:Firmados 2:Sin Firmar
export const getEmployeeContracts = async (signedFilter: 0 | 1 | 2, requestId: (typeof EMPLOYEE_CONTRACTS_ONE | typeof EMPLOYEE_CONTRACTS_TWO | typeof EMPLOYEE_CONTRACTS_THREE)) => {
	const companyselected = store.getState().auth.companyselected;
	const request = `dbo.S10_15_IdentificadorContrato_ListarEnviadosConFiltro '${companyselected?.Code}',${signedFilter},'',200,1,null`;
	await signalGenericRequest(
		requestId,
		request,
	);
}

/*
sp que lista los prestamos por persona:
[dbo].[s10_15_Identificador_ListarPrestamosPorEstado]
@CodIdentificador VARCHAR(8),
@Estado TINYINT --0:Pendientes 1:Historicos
*/
export const getEmployeeLoans = async (state: 0 | 1, requestId: (typeof EMPLOYEE_LOANS_ONE | typeof EMPLOYEE_LOANS_TWO | typeof EMPLOYEE_LOANS_THREE), pageQuantity: number, pageNumber: number) => {
	const companyselected = store.getState().auth.companyselected;
	const request = `dbo.s10_15_Identificador_ListarPrestamosPorEstado '${companyselected?.Code}',${state},${pageQuantity},${pageNumber}`;
	await signalGenericRequest(
		requestId,
		request,
		true,
	);
}

/*
[dbo].[S10_15_PrestamoPersonal_AdicionarDesdePortal]
@EMailUsuario VARCHAR(128) = Null,
@CodIdentificador VARCHAR(8),
@NroTipoPrestamo UNIQUEIDENTIFIER,
@NumeroExpediente VARCHAR(20),
@Fecha DATETIME,
@TipoCuotas TINYINT,
@NumeroCuotas TINYINT,
@Observaciones VARCHAR(250),
@MontoSolicitado NUMERIC(25,6),
@NroProyectoEsquemaPeriodo UNIQUEIDENTIFIER,
@CodMoneda VARCHAR(2),
@CodIdentificadorExpediente VARCHAR(8)=Null,
@DescripcionExpediente VARCHAR(250)=Null,
@MontoCuota NUMERIC(25,6)=Null,
@CuotaDoble TINYINT=0,
@Cronograma VARCHAR(8000)=Null
*/
export const setEmployeeLoan = async (
	rucSelected: string,
	loanType: string,
	installmentType: string,
	numberOfInstallments: string,
	requestedAmount: string,
	currencyId: string,
	installmentAmount: string,
	doubleInstallmentAmount: number,
	schedule: string,
	nroProyectoEsquemaPeriodo: string,
	date: string,
	principalsCodes: string,
) => {
	const { companyselected, sessionData } = store.getState().auth;
	const request = `dbo.S10_15_PrestamoPersonal_AdicionarDesdePortal '${sessionData?.UserName}','${companyselected?.Code}','${loanType}',null,'${date}',${installmentType},${numberOfInstallments},'',${requestedAmount},${nroProyectoEsquemaPeriodo ? `'${nroProyectoEsquemaPeriodo}'` : 'null'},'${currencyId}',null,null,${installmentAmount || 'null'},${doubleInstallmentAmount || 'null'},'${schedule}','${rucSelected}','${principalsCodes}'`;
	await signalGenericRequest(
		EMPLOYEE_LOAN_REQUEST,
		request,
	);
}

/*
[dbo].[S10_15_PrestamoPersonal_ActualizarTieneNota]
	@NroPrestamoPersonal	UNIQUEIDENTIFIER,
	@TieneNota				BIT
*/
export const setEmployeeLoanHasNote = async (loanId: string, hasNote: 1 | 0) => {
	const request = `dbo.S10_15_PrestamoPersonal_ActualizarTieneNota '${loanId}',${hasNote}`;
	const result = await signalGenericRequest(
		EMPLOYEE_LOAN_UPDATE_NOTE,
		request,
	);
	return result;
}

export const getEmployeeLoanDetails = async (nroPrestamoPersonal: string) => {
	const request = `dbo.s10_15_PrestamoPersonal_ListarCronograma '${nroPrestamoPersonal}'`;
	await signalGenericRequest(
		EMPLOYEE_LOAN_DETAILS,
		request,
	);
}

export const setEmployeeLoanCancel = async (nroPrestamoPersonal: string) => {
	const request = `dbo.S10_15_PrestamoPersonal_EliminarDesdePortal '${nroPrestamoPersonal}'`;
	await signalGenericRequest(
		EMPLOYEE_LOAN_CANCEL_RESULT,
		request,
	);
}


export const getEmployeeLoanTypes = async () => {
	const request = `dbo.s10_15_TipoPrestamo_ListarTodos`;
	await signalGenericRequest(
		EMPLOYEE_LOANS_TYPES,
		request,
	);
}

export const getEmployeeLoanPeriod = async (date: string) => {
	const companyselected = store.getState().auth.companyselected;
	const request = `dbo.S10_15_ProyectoEsquema_ListarPeriodosPorFecha '${companyselected?.Code}', '${date}'`;
	await signalGenericRequest(
		EMPLOYEE_LOAN_PERIOD,
		request,
	);
}
export const getEmployeeLoanCurrencies = async () => {
	const request = `dbo.S10_00_Moneda_ListarPorDescripcion ''`;
	await signalGenericRequest(
		EMPLOYEE_LOANS_CURRENCIES,
		request,
	);
}


export const setContractObservation = async (contractNumber: string, observation: string) => {
	await signalGenericRequest(
		CONTRACT_OBSERVATION,
		`dbo.S10_15_IdentificadorContrato_Observar '${contractNumber}', '${observation}'`,
	);
}


export const validateCouponDateRange = async (dateStart: Date, dateEnd: Date) => {
	const companyselected = store.getState().auth.companyselected;
	const from = getDatestring(dateStart, "/", false);
	const to = getDatestring(dateEnd, "/", false);
	await signalGenericRequest(
		COUPON_RANGE_VALIDATION,
		`dbo.S10_15_Identificador_ObtenerSaldoFraccionadoVacaciones '${companyselected?.Code}', '${from}', '${to}'`,
	);
}

export const getUsersEmailsByCodes = async (employeesCodes: string[]) => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		COUPON_REQUEST_RESPONSIBLE_EMAILS,
		`dbo.s10_06_Proyecto_ListarUsuariosPorCodigo '${companyselected?.Code}|${employeesCodes.join("|")}'`,
	);
}

export const getUserInformation = async () => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		GET_EMPLOYEE_INFORMATION,
		`dbo.S10_00_Identificador_LeerRegistroPorCodigo '${companyselected?.Code}'`,
	);
}

export const updateUserDataRequest = async (newData: UserDataToUpdate) => {
	const { companyselected, userData } = store.getState().auth;
	await signalGenericRequest(
		UPDATE_USER_DATA,
		`dbo.S10_00_Identificador_ActualizarDatosColaborador '${userData?.EMail}', '${companyselected?.Code}', '${newData?.ApellidoPaterno}', '${newData?.ApellidoMaterno}', '${newData?.Nombres}', '${newData?.Sexo}', '${newData?.Direccion}', 'NULL', '${newData?.TelefonoMovil}'`,
	);
}

export const getUserRightHolders = async () => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		GET_EMPLOYEE_RIGHT_HOLDERS,
		`dbo.S10_00_Identificador_ListarHijos '${companyselected?.Code}'`,
	);
}

export const setUserRightHolder = async (data: UserUpdateRightHolder) => {
	const { companyselected, userData } = store.getState().auth;
	await signalGenericRequest(
		UPDATE_EMPLOYEE_RIGHT_HOLDERS,
		`dbo.S10_15_IdentificadorDerechoHabiente_ActualizarDesdePortal 'null', '${companyselected?.Code}', '${data.DNI}', '${data.ApellidoPaterno}', '${data.ApellidoMaterno}', '${data.Nombres}', '${data.FechaNacimiento}', '${userData?.EMail}', ${data.Operacion}`,
	);
}



export const getColleges = async () => {
	const { colleges } = store.getState().auth;
	if (colleges.length) return;
	await signalGenericRequest(
		GET_COLLEGES,
		`dbo.S10_00_TablaTablas_Listar 'INSTITUCIONEDUCATIVA'`,
	);
}

export const getUserTraining = async () => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		GET_EMPLOYEE_TRAINING,
		`dbo.S10_00_Identificador_ListarCapacitacion '${companyselected?.Code}'`,
	);
}

export const setUserTraining = async (data: UserUpdateTraining) => {
	const { companyselected, userData } = store.getState().auth;
	await signalGenericRequest(
		SET_EMPLOYEE_TRAINING,
		`dbo.S10_15_IdentificadorCapacitacion_ActualizarDesdePortal 'null','${companyselected?.Code}', '${data.CodTipoCapacitacion}', '${data.CodInstitucionEducativa}', '${data.Descripcion}', '${data.FechaInicio}', '${data.FechaFin}', '${userData?.EMail}', ${data.Operacion}, '${data.guid}'`,
	);
}

export const getContactsS10 = async (data: S10ContactsRequest) => {
	const request = data.staffPosition
		? `dbo.S10_15_ProyectoIdentificadorEsquema_ListarPersonalPorRUCTipoNominaDescripcion '${data.onlyActives}','${data.ruc}','${data.staffPosition}','${data.description}','${data.pageQuantity}','${data.pageNumber}'`
		: `dbo.S10_15_ProyectoIdentificadorEsquema_ListarPersonalTodosPorRUCDescripcion '${data.onlyActives}','${data.ruc}','${data.description}','${data.pageQuantity}','${data.pageNumber}'`
	await signalGenericRequest(
		GET_CONTACTS,
		request,
		true,
	);
}


export const getStaffPositions = async (ruc: string) => {
	await signalGenericRequest(
		GET_STAFF_POSITIONS,
		`dbo.S10_15_EsquemaPlanilla_ListarPorEmpresa '${ruc}'`,
	);
}

export const getEmployeeHealthPlan = async () => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		GET_HEALTH_PLAN,
		`dbo.S10_15_ProyectoObrero_ListarRegimenSalud '${companyselected?.Code}'`,
	);
}

export const getEmployeeVacationsResume = async (rucSelected: string) => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		GET_VACATIONS_RESUME,
		`dbo.S10_15_Identificador_ListarVacaciones '${companyselected?.Code}','${rucSelected}'`,
	);
}

export const getApprovalGroupsCompanies = async () => {
	await signalGenericRequest(
		APPROVAL_GROUPS_COMPANIES,
		`dbo.S10_00_Identificador_ListarEmpresasGrupo`,
	);
}

export const getAssignedCompanies = async () => {
	const companyselected = store.getState().auth.companyselected;
	await signalGenericRequest(
		USER_ASSIGNED_COMPANIES,
		`dbo.S10_15_ProyectoIdentificadorEsquema_ListarEmpresasActivo '${companyselected?.Code}'`,
	);
}

export const getEmployeesAdditionalDataById = async (
	requestId: (typeof APPROVAL_RESPONSABLES |
		typeof APPROVAL_EMPLOYEES |
		typeof PENDING_COUPONS_EMPLOYEES_ONE |
		typeof PENDING_COUPONS_EMPLOYEES_HISTORY_ONE |
		typeof PENDING_COUPONS_EMPLOYEES_TWO |
		typeof PENDING_COUPONS_EMPLOYEES_HISTORY_TWO |
		typeof PENDING_COUPONS_EMPLOYEES_THREE |
		typeof PENDING_COUPONS_EMPLOYEES_HISTORY_THREE),
	approvalResponsablesIds: string[] | string
) => {
	let ids: string = ""
	if (typeof approvalResponsablesIds === 'object') {
		ids = approvalResponsablesIds.join("|")
	} else {
		ids = approvalResponsablesIds;
	}
	await signalGenericRequest(
		requestId,
		`dbo.s10_15_ProyectoIdentificadorEsquema_ListarPersonalPorCodigo '${ids}'`,
	);
}

export const getEmployeesAdditionalDataByIdForOrganigram = async (
	requestId: (typeof APPROVAL_EMPLOYEES),
	approvalResponsablesIds: string[] | string
) => {
	let ids: string = ""
	if (typeof approvalResponsablesIds === 'object') {
		ids = approvalResponsablesIds.join("|")
	} else {
		ids = approvalResponsablesIds;
	}
	await signalGenericRequest(
		requestId,
		`dbo.s10_15_ProyectoIdentificadorEsquema_ListarPersonalResumenPorCodigo '${ids}'`,
	);
}

export const getCompanyEmployees = async (ruc: string, pageSize: number, pageNumber: number, description: string = "") => {
	await signalGenericRequest(
		COMPANY_EMPLOYEES,
		`dbo.S10_15_ProyectoIdentificadorEsquema_ListarPersonalRUCEmpresaPorDescripcion 1,'${ruc}',${pageSize},'${description}',${pageNumber}`,
		true,
	);
}

export const getCompanyEmployeesVacationsResume = async (employeeCodes: string, ruc: string, pageSize: number, pageNumber: number, description: string = "") => {
	await signalGenericRequest(
		COMPANY_EMPLOYEES,
		`dbo.S10_15_VacacionProgramada_ListarResumenPorSocioNegocio '${employeeCodes}','${ruc}','${description}',${pageSize},${pageNumber}`,
		true,
	);
}

export const getLoansToApprove = async (
	requestId: LoansToMyChargeRequestId,
	employeeCodes: string,
	ruc: string,
	status: 0 | 1 | 2,
	pageSize: number,
	pageNumber: number,
	description: string = ""
) => {
	const { sessionData } = store.getState().auth;
	await signalGenericRequest(
		requestId,
		`dbo.S10_15_PrestamoPersonal_ListarPorSocioNegocioEstado '${sessionData?.UserName}','${employeeCodes}','${ruc}',${status},'${description}',${pageSize},${pageNumber}`,
		true,
	);
}

// @Estado TINYINT --0:Quitar aprobacion 1:Aprobar 2: denegar
export const setLoanStatus = async (
	requestId: LoansToMyChargeRequestId,
	loanId: string,
	status: 0 | 1 | 2,
) => {
	const { sessionData } = store.getState().auth;
	const requestStatusId = requestId === LOANS_TO_MY_CHARGE_HISTORY_ONE
		? LOANS_TO_MY_CHARGE_UPDATE_STATUS_ONE
		: requestId === LOANS_TO_MY_CHARGE_HISTORY_TWO
			? LOANS_TO_MY_CHARGE_UPDATE_STATUS_TWO
			: LOANS_TO_MY_CHARGE_UPDATE_STATUS_THREE;
	return await signalGenericRequest(
		requestStatusId,
		`dbo.S10_15_PrestamoPersonal_CambiarEstadoDesdePortal '${sessionData?.UserName}','${loanId}',${status}`,
		true,
	);
}

export const getCompanyEmployeesVacationsDetails = async (codes: string, ruc: string, description: string, pageSize: number, pageNumber: number) => {
	await signalGenericRequest(
		EMPLOYEES_VACATIONS_RESUME,
		`dbo.S10_15_Identificador_ListarVacacionProgramadaPorEmpresa '${codes}','${ruc}','${description}',${pageNumber}`,
		true,
	);
}

export const setAproveCouponERP = async ({ ApprovalCode, EmployeeCode, RangeStart, RangeEnd, CouponCode, RangeCount, }: S10CouponsToMyChargePartial) => {
	const { sessionData } = store.getState().auth;
	const request = `dbo.S10_15_ProyectoObreroPapeleta_AdicionarDesdePortal '${ApprovalCode}','','${EmployeeCode}','${RangeStart}','${RangeEnd}','${CouponCode}','${RangeCount}','${sessionData?.UserName}'`;
	return await signalGenericRequest(
		APPROVE_COUPON,
		request,
		true,
	);
}

export const setCancelApprovedCoupon = async (erpCode: string) => {
	const request = `dbo.S10_15_ProyectoObreroPapeleta_QuitarAprobacionDesdePortal '${erpCode}'`;
	return await signalGenericRequest(
		CANCEL_APPROVED_COUPON,
		request,
	);
}

export const setEmployeesContractsData = async (
	requestId: InMyChargeEmployeeContractsRequestId,
	employeeCodes: string,
	rucSelected: string,
	filter: InMyChargeEmployeeContractsRequestFilter,
	description: string,
	pageSize: number,
	page: number,
) => {
	const request = `dbo.S10_15_IdentificadorContrato_ListarEnviadosPorSocioNegocio '${employeeCodes}','${rucSelected}',${filter},'','','${description}',${pageSize},${page}`;
	return await signalGenericRequest(
		requestId,
		request,
		true,
	);
}

export const setEmployeesPaymentSlipsData = async (
	requestId: InMyChargeEmployeePaymentSlipsRequestId,
	ruc: string,
	employeeCodes: string,
	filter: InMyChargeEmployeePaymentSlipsRequestFilter,
	description: string,
	pageSize: number,
	page: number,
) => {
	const finalRuc = ruc === 'all' ? '' : ruc;
	const request = `dbo.S10_15_BoletaNomina_ListarEnviadosPortalPorSocioNegocioEmpresa '${employeeCodes}','${finalRuc}',${filter},'','','${description}',${pageSize},${page}`;
	return await signalGenericRequest(
		requestId,
		request,
		true,
	);
}



export const getEmployeesPaymentSlipsSchemeTypesData = async (
	ruc: string,
) => {
	const finalRuc = ruc === 'all' ? '' : ruc;
	const request = `dbo.S10_15_EsquemaPlanilla_ListarPorEmpresa '${finalRuc}'`;
	return await signalGenericRequest(
		IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_SCHEME_TYPES,
		request,
	);
}

export const setEmployeesPaymentSlipsDataDownload = async (
	ruc: string,
	employeeCodes: string,
	schemeCode: string,
	startDate: string,
	endDate: string,
	pageSize: number,
	page: number,
) => {
	/*
	[dbo].[S10_15_BoletaNomina_ListarEnviadosPortalPorSocioNegocioEmpresaTN] 
		@CodIdentificador	Varchar(8000) = Null,
		@RUC				VARCHAR(20) = '',
		@NroEsquemaPlanilla	UNIQUEIDENTIFIER = Null, 
		@FechaInicio		VARCHAR(10) = '',
		@FechaFin			VARCHAR(10) = '',
		@TamanoPagina		INTEGER = 50,
		@NumeroPagina		INTEGER = 1,
		@EtiquetaPagina		VARCHAR(20)  = Null OUTPUT
	*/
	const finalRuc = ruc === 'all' ? '' : ruc;
	const params = `'${employeeCodes}','${finalRuc}','${schemeCode}','${startDate}', '${endDate}', ${pageSize},${page}`
	const request = `dbo.S10_15_BoletaNomina_ListarEnviadosPortalPorSocioNegocioEmpresaTN ${params}`;
	return await signalGenericRequest(
		IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE,
		request,
		true,
	);
}

export const setEmployeesDocumentsData = async (
	requestId: InMyChargeEmployeeDocumentsRequestId,
	ruc: string,
	employeeCodes: string,
	filter: InMyChargeEmployeeDocumentsRequestFilter,
	description: string,
	pageSize: number,
	page: number,
) => {
	const finalRuc = ruc === 'all' ? '' : ruc;
	const request = `dbo.S10_15_DocumentoPersonal_ListarEnviadosPortalPorSocioNegocioEmpresa '${employeeCodes}','${finalRuc}',${filter},'${description}',${pageSize},${page}`;
	return await signalGenericRequest(
		requestId,
		request,
		true,
	);
}

export const signalGetCouponstData = async () => {
	const request = `dbo.s10_00_PaqueteEnvio_ListarClasificacionPapeletas`;
	return await signalGenericTransportDataRequest(
		"transporteClasificacionPapeletas",
		request,
		false,
	);
}


export const getYearHolidays = async (year = new Date().getFullYear()) => {
	await signalGenericRequest(
		GET_YEAR_HOLIDAYS,
		`dbo.s10_00_ConfiguracionFeriado_ListarPorAno '${year}'`,
	);
}

export const getBankAccountsConfig = async () => {
	await signalGenericRequest(
		BANK_ACCOUNTS_CONFIG,
		`dbo.S10_00_ConfiguracionS10_ListarSeteoPortalColaborador`,
	);
}

export const getBankAccounts = async () => {
	const { companyselected } = store.getState().auth;
	await signalGenericRequest(
		BANK_ACCOUNTS_LIST,
		`dbo.S10_00_IdentificadorCuentaBanco_Listar '${companyselected?.Code}'`,
	);
}

export const getBanksList = async () => {
	await signalGenericRequest(
		BANKS_LIST,
		`dbo.S10_09_OB_Banco_Listar`,
	);
}

export const getCurrenciesList = async () => {
	await signalGenericRequest(
		CURRENCIES_LIST_GENERIC,
		`dbo.S10_00_Moneda_ListarPorDescripcion ''`,
	);
}

export const addBankAccount = async (data: any) => {
	const { companyselected, sessionData } = store.getState().auth;

	const request = `Dbo.S10_00_IdentificadorCuentaBanco_Adicionar null, '${companyselected?.Code}', '${data.Banco_ID}', '${data.TipoCuentaBanco}', '${data.NoCuenta}', '${data.Descripcion}', '${data.CodMoneda}', null, null, ${data.Activo ? 1 : 0}, ${data.Predeterminado ? 1 : 0}, '${data.CuentaInterBancaria}', '${data.NoCuentaCargo}', null, '${sessionData?.UserName}'`;

	await signalGenericRequest(
		BANK_ACCOUNT_ADD,
		request,
	);
}

export const updateBankAccount = async (data: any) => {
	const { companyselected, sessionData } = store.getState().auth;
	const request = `dbo.S10_00_IdentificadorCuentaBanco_Modificar '${data.NroIdentificadorCuentaBanco}', '${companyselected?.Code}', '${data.Banco_ID}', '${data.TipoCuentaBanco}', '${data.NoCuenta}', '${data.Descripcion}', '${data.CodMoneda}', 'null', 'null', ${data.Activo ? 1 : 0},  ${data.Predeterminado ? 1 : 0},'${data.CuentaInterBancaria}', '${data.NoCuentaCargo}', 'null', '${sessionData?.UserName}'`;

	await signalGenericRequest(
		BANK_ACCOUNT_UPDATE,
		request,
	);
}

export const deleteBankAccount = async (id: string) => {
	await signalGenericRequest(
		BANK_ACCOUNT_DELETE,
		`dbo.S10_00_IdentificadorCuentaBanco_EliminarSeleccion '${id}'`,
	);
}
